import {
    CORE_LOAD_MASTER_DATA_MATERIALS_REQUEST,
    CORE_LOAD_MASTER_DATA_MATERIALS_SUCCESS,
    CORE_LOAD_MASTER_DATA_MATERIALS_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterMaterials: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_MATERIALS_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_MATERIALS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_MATERIALS_FAILURE:
                return []
            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/material.js